import React from "react";
import "../styleSheet/Landing.css";
import { useNavigate } from "react-router-dom";
import icon from "../images/icon.png";


export default function Footer() {
  const navigate = useNavigate();
  return (
    <div className="section6">
      <div className="footerContent">
        <h4>CV Tuner Edjobster</h4>
        <h6 className="subHeadingSec6">
          Resumes Redefined, Success Rewritten.
        </h6>
        <div className="row footerLinks">
          <div className="col-md-4">
            <h6>Quick Links</h6>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/aboutus");
                window.scrollTo(0, 0);
              }}
            >
              About Us
            </p>
            <p
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 1440);
              }}
            >
              How It works
            </p>
            <p
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 2150);
              }}
            >
              Features
            </p>
            <p
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 2750);
              }}
            >
              Testimonials
            </p>
          </div>
          <div className="col-md-4">
            <h6>Privacy and Terms</h6>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/privacypolicy");
                window.scrollTo(0, 0);
              }}
            >
              Privacy Policy
            </p>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/termsandconditions");
                window.scrollTo(0, 0);
              }}
            >
              Terms Of Service
            </p>
          </div>
          <div className="col-md-4">
            <h6>Connect with us</h6>
            <p>Email : info@edjobster.com</p>
            <p>Mobile : 
            +919325906569</p>
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
        <p className="footerText" style={{color :"white"}}>Powered by<img className="footerIcon" src={icon} alt="Powered by"/></p>
        </div>
        </div>
    </div>
  );
}